import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { BugReportDialog } from '@/components/support/BugReportDialog';
import { LogOut, Bug } from 'lucide-react';

export const Header = () => {
  const { signOut, user } = useAuth();
  const { t } = useTranslation();
  const [bugReportOpen, setBugReportOpen] = useState(false);

  return (
    <>
      <header className="flex h-16 items-center justify-between border-b border-border bg-card px-3 md:px-6">
        <div className="flex items-center gap-2 md:gap-4">
          <span className="hidden md:block text-sm text-muted-foreground">{user?.email}</span>
        </div>
        <div className="flex items-center gap-2 md:gap-4">
          <Button 
            variant="ghost" 
            size="sm" 
            onClick={() => setBugReportOpen(true)}
            className="text-muted-foreground"
          >
            <Bug className="h-4 w-4" />
            <span className="hidden md:inline ml-2">{t('support.reportIssue')}</span>
          </Button>
          
          <LanguageSwitcher />
          <Button variant="ghost" size="sm" onClick={signOut}>
            <LogOut className="h-4 w-4" />
            <span className="hidden md:inline ml-2">{t('auth.signOut')}</span>
          </Button>
        </div>
      </header>

      <BugReportDialog open={bugReportOpen} onOpenChange={setBugReportOpen} />
    </>
  );
};
